import { IClassroomResource } from "../../classrooms";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IClassroom } from "../types";

export type IClassroomQueryParameters = {
    classroom?: RelationalValue<IClassroomResource>;
};

export type IClassroomQueryResult = IClassroom;

export const classroomQuery: IApiQueryFunction<IClassroomQueryParameters> = ({ classroom }) => {
    if (!classroom) {
        return;
    }

    return {
        method: "GET",
        url: `/classrooms/${mapRelationalValue(classroom)}`,
    };
};

export const useClassroomQuery = createApiQueryHook<IClassroomQueryParameters, IClassroomQueryResult>(classroomQuery);
